import { z } from 'zod';

import { ContractType } from '@/common/graphql';

export const EmployeeContractHistory = z.object({
  id: z.string().default(''),
  effectiveDateStart: z.string().default(''),
  effectiveDateEnd: z.string().nullable().default(null),
  companyId: z.string().nullable().default(null),
  companyName: z.string().nullable().default(null),
  type: z.nativeEnum(ContractType).nullable().default(null),
  employeeCode: z.string().nullable().default(null),
  isOnSecondment: z.boolean().default(false),
  isMain: z.boolean().default(true),
  isPreAcquisition: z.boolean().default(false),
  companyAcquiredDate: z.string().nullable().default(null),
});
export type EmployeeContractHistoryType = z.infer<typeof EmployeeContractHistory>;
